import { ButtonWidget, DialogPositioningBehavior, DialogType, TabStyles } from '@tableau/widgets';
import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { MarkupField } from '../Explorer/widgets/MarkupField';
import { SpaceHeaderTestIds } from './SpaceHeader';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

export const maxDescriptionHeight = 150;

export function ItemDescription(props: {
  item: { description: string };
}): JSX.Element {
  const { ref: containerRef } = useResizeDetector({ handleHeight: false });
  const descriptionElementRef = React.useRef<HTMLDivElement>(null);
  const shouldRenderShowMore =
    descriptionElementRef.current
    && descriptionElementRef.current.scrollHeight > maxDescriptionHeight;

  return <div ref={containerRef}>
    <div ref={descriptionElementRef} data-tb-test-id={SpaceHeaderTestIds.description} className={SpaceHeaderStyles.ItemDescription} style={{ maxHeight: maxDescriptionHeight, overflow: 'auto' }}>
      <MarkupField testId={'detail-dialog-description'} markup={props.item.description} excludeImages disableMaxHeight />
    </div>
    {
      shouldRenderShowMore && <div className={footerStyle}>
        <ButtonWidget onClick={() => {
          ReactModalService.open({
            title: Messages.about(),
            testId: 'test',
            type: DialogType.NormalWithTitleBar,
            showCloseButton: true,
            positioningBehavior: DialogPositioningBehavior.Centered,
            dialogWidth: TabDialogWidth.width700px,
            dialogHeight: 700,
            dialogBodyStyle: {},
            dialogContent: <div><MarkupField testId={'detail-dialog-description'} markup={props.item.description} disableMaxHeight /></div>,
          });
        }}>{Messages.channelShowMoreButton()}</ButtonWidget>
      </div>
    }
  </div>;
}

export const footerStyle = style({
  marginTop: TabStyles.Spacing.MediumSpace
});